import { render, staticRenderFns } from "./ProjectAbout.vue?vue&type=template&id=434f8f50&scoped=true&"
import script from "./ProjectAbout.vue?vue&type=script&lang=ts&"
export * from "./ProjectAbout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434f8f50",
  null
  
)

export default component.exports